<template>
  <div id="app" class="flex flex-col h-screen overflow-hidden" :class="{ 'dark': darkMode }">
    <NavHeader />
    <!-- 主内容区域：壳固定不滚动、无留白，各页面自行决定留白与滚动 -->
    <main class="flex-1 min-h-0 overflow-hidden flex flex-col bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <router-view class="min-h-0 flex-1 flex flex-col" />
    </main>
  </div>
</template>

<script>
import { computed } from 'vue'
import NavHeader from '@/features/nav-header'

export default {
  name: 'App',
  components: { NavHeader },
  data() {
    return {
      darkMode: false
    }
  },
  provide() {
    const self = this
    return {
      darkMode: computed(() => self.darkMode),
      toggleDarkMode: () => self.toggleDarkMode()
    }
  },
  mounted() {
    // 检查用户偏好设置
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.darkMode = true;
    }
    
    // 监听系统主题变化
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
      this.darkMode = event.matches;
    });
  },
  methods: {
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
    }
  }
}
</script>

<style>
/* 保留字体设置，其他样式已通过Tailwind类实现 */
#app {
  font-family: system-ui, -apple-system, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
